// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f8423a0b","453":"5d8bb65f","455":"a2abe85a"}[chunkId] + ".chunk.js";
};